import { render, staticRenderFns } from "./CierreUrgenciaView.vue?vue&type=template&id=7ba3a614"
import script from "./CierreUrgenciaView.vue?vue&type=script&lang=js"
export * from "./CierreUrgenciaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports